var product = {
    featuredImage: $('.featured_image').attr('src'),

    onClick: function(){
        $('.product-thumb').on('click', function(){
            $('.product-thumb').removeClass('border');
            $(this).addClass('border');
            var hoverImage = $(this).find('img');
            $('.featured_image').attr('src', hoverImage.attr('src'));
        });
    },

  
};

product.onClick();

$(document).ready(function(){
    $(".product-slider").owlCarousel({
        loop:true,
        margin:130,
        slideBy:1,
        nav:true,
        center: true,
        navSpeed: 1500,
        navText: ['<i class="fas fa-angle-left" aria-hidden="true"></i>', '<i class="fas fa-angle-right" aria-hidden="true"></i>'],
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:3
            }
        }
    });

    //variant change price update
    $('select.variant-select').on('change', function(){
        var price = $(this).find(":selected").data('price');
        var compare = $(this).find(":selected").data('compare-price');
        console.log(price);
        console.log(compare);
        if(compare !== "$0.00"){
            $('.product-price').empty().append(compare);
            $('.orginal-price').empty().append(price);
        }

        else{
            $('.product-price').empty().append(price);
        }
      
    });
});

let lazyImages = [...document.querySelectorAll('.lazy-image')]
let inAdvance = 300

console.log(lazyImages);
function lazyLoad() {
    lazyImages.forEach(image => {
        if (image.offsetTop < window.innerHeight + window.pageYOffset + inAdvance) {
            image.src = image.dataset.src
            image.onload = () => image.classList.add('loaded')
        }
    })

    // if all loaded removeEventListener
}

lazyLoad()

window.addEventListener('scroll',lazyLoad)
window.addEventListener('resize', lazyLoad, 16)



